import React, { useEffect, useState } from "react";
import { useFormContext, useController } from "react-hook-form";
import { InputLabel } from "../Inputs";
import { InputErrorMessage } from "components/atoms";

interface PaziaButtonSwitchProps {
  a: string;
  b: string;
  c: string;
  d?: string;
  name: string;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  onChange?: (opt: string) => void;
}
export const PaziaButtonSwitch = ({
  name,
  label,
  onChange,
  required,
  disabled,
  a,
  b,
  c,
  d,
}: PaziaButtonSwitchProps): JSX.Element => {
  const { control } = useFormContext();

  const { field } = useController({
    name,
    control,
  });

  const onChangeHandler = (val: string) => {
    field.onChange(val);
    if (onChange) onChange(val);
  };

  return (
    <div>
      <InputLabel label={label} required={required} name={name} />
      <ButtonSwitch onChange={onChangeHandler} a={a} b={b} c={c} d={d} disabled={disabled} value={field.value} />
      <InputErrorMessage name={name} />
    </div>
  );
};

interface ButtonSwitchProps {
  a: string;
  b: string;
  c?: string;
  d?: string;
  disabled?: boolean;
  className?: string;
  value?: string;
  onChange: (opt: string) => void;
}

export const ButtonSwitch = ({ a, b, c, d, value, onChange, className, disabled }: ButtonSwitchProps): JSX.Element => {
  const [activeOption, setActiveOption] = useState(value);

  // Keep the highlighted option in sync when the parent changes `value` (e.g. a reset on modal close).
  useEffect(() => {
    setActiveOption(value);
  }, [value]);
  const items = [a, b, c, d].filter((x) => x !== undefined) as string[];

  return (
    <div className={`h-9 flex items-center p-1 bg-gray-200 dark:bg-slate-700 rounded-md ${className ?? ""}`}>
      {items
        .filter((x) => x !== undefined)
        .map((option) => (
          <div
            key={option}
            className={`flex-1 text-center py-1 px-2 rounded-md transition-all duration-300
            ${
              activeOption === option
                ? "bg-primary-500 text-white"
                : disabled
                ? "cursor-not-allowed text-slate-400"
                : "cursor-pointer"
            }`}
            onClick={() => {
              if (disabled) return;
              onChange(option);
              setActiveOption(option);
            }}
          >
            {option}
          </div>
        ))}
    </div>
  );
};
